import React, {
  PropsWithChildren,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import styles from "./styles.module.scss";
import clsx from "clsx";
import { Focusable, useSpatialNavigation } from "@blacknut/spatialnav-sdk/dist";
const Accordion = ({
  children,
  expanded,
  onChange,
}: PropsWithChildren<{
  expanded: boolean;
  onChange: (expanded: boolean) => void;
}>) => {
  const [hasContent, setHasContent] = useState(expanded);
  const toggle = useCallback(() => {
    onChange(!expanded);
  }, [expanded, onChange]);
  const timeoutRef = useRef<NodeJS.Timer>();
  const { active } = useSpatialNavigation();
  useEffect(() => {
    clearTimeout(timeoutRef.current as unknown as number);
    if (!expanded) {
      timeoutRef.current = setTimeout(() => {
        setHasContent(expanded);
      }, 500);
    } else {
      setHasContent(expanded);
    }
  }, [expanded]);
  useEffect(() => {
    return () => {
      clearTimeout(timeoutRef.current as unknown as number);
    };
  }, []);
  const ch = React.Children.toArray(children);

  // TODO check if fragment

  return (
    <div
      className={clsx([
        styles.container,
        expanded && styles.expanded,
        active && styles.focusable,
      ])}
    >
      <Focusable onPressEnter={toggle} onClick={toggle}>
        {ch[0]}
      </Focusable>
      {hasContent && ch.slice(1)}
    </div>
  );
};
export default Accordion;
export { Accordion };
